<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <a-button
        type="primary"
        shape="round"
        icon="plus"
        :style="{ float: 'right', marginTop: '19px' }"
        @click="editAndAdd"
      >
        新增样品赠品
      </a-button>
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
        <template
          slot="attach_doc_info_list"
          slot-scope="text,record"
        >
          <a
            v-for="(item,index) in record.attach_doc_info_list"
            :key="item.id"
            :href="item.url"
          >{{ item.name }}{{ index===record.attach_doc_info_list.length-1?'':'、' }}</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.data.status===1?'禁用':'启用'"
            :alert-title="record.data.status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <product-modal
      ref="formRef"
      :is-visible-brand="isVisibleBrand"
      :title="title"
      @onCancel="onCancel"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </product-modal>
  </div>
</template>
<script>
import { companyColumns } from './data/index';
import { getProduct, getCompany } from './utils/dealTable';
import ProductModal from './modal/index.vue';
export default {
  components: { ProductModal },
  data() {
    return {
      btnIsLoading: false,
      selectData: [],
      columns: companyColumns,
      tableData: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: true,
      isVisibleBrand: false,
      title: '',
      brandId: undefined,

    };
  },
  mounted() {
    // 获取表格数据
    this.getTableData({ page: this.current, pageSize: this.pageSize });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/Gift/getList', params);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;

        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            name: item.name,
            link_products: getProduct(item.link_product_list),
            attach_doc_info_list: item.attach_doc_info_list,
            summary: item.summary,
            data: item,
          };
          temp.push(obj);
        });
        this.tableData = temp;
      }
    },
    // 编辑或新增
    editAndAdd(record) {
      console.log('TCL: editAndAdd -> record', record);
      this.isVisibleBrand = true;
      if (!record.id) {
        // 新增
        this.title = '新增样品';
        this.brandId='';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        // 编辑
        this.brandId = record.id;
        this.title = '编辑样品';
        this.$nextTick(() => {
          let fileList=record.data.attach_doc_info_list.map((item)=>{
            return {
              name: item.name,
              uid: item.id,
              url: item.url,
              status: 'done',
            };
          });
          let data = {
            name: record.data.name,
            link_products: record.data.link_products.split(',').map((item)=>parseInt(item)),
            attach_doc_ids: fileList,
            summary: record.data.summary,
          };
          console.log(data);
          this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
        });
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('onSubmit -> values', values);
          if (!err) {
            values.attach_doc_ids=values.attach_doc_ids.map((item)=>item.response?item.response.data.id:item.uid).join();
            values.link_products=values.link_products.join();
            console.log('onSubmit -> values', values);
            this.btnIsLoading=true;
            let result = await this.$http.post('/Gift/update', {
              ...values,
              id: this.brandId,
            });
            this.btnIsLoading=false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.isVisibleBrand = false;
              this.getTableData({ page: this.current, pageSize: this.pageSize });
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.isVisibleBrand = false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('/Gift/setStatus', {id: record.id, status: record.data.status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 删除
    async onDelete(record) {
      let result=await this.$http.post('/Gift/setStatus', {id: record.id, status: -1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({ page: this.current, pageSize: this.pageSize });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({
        page: pagination.current,
        pageSize: pagination.pageSize,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
</style>
